var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-0.4%",
    width: "102.2%",
    height: "101.0%",
    filterUnits: "objectBoundingBox",
    className: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0920290647 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-2.4%",
    width: "103.1%",
    height: "105.5%",
    filterUnits: "objectBoundingBox",
    className: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.838768116   0 0 0 0 0.838768116   0 0 0 0 0.838768116  0 0 0 0.541111233 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-438.000000, -476.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F1F2F2",
    x: 0,
    y: 0,
    width: 1024,
    height: 1834
  }), /*#__PURE__*/React.createElement("g", {
    className: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 112,
    width: 780,
    height: 1722,
    rx: 10,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 112,
    width: 780,
    height: 1722,
    rx: 10,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Dropdown"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 618,
    height: 348,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 618,
    height: 348,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "border",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0.5 C11.346,0.5 13.4710397,1.45193294 15.0095534,2.99044661 C16.5480671,4.52896028 17.5,6.654 17.5,9 C17.5,11.346 16.5480671,13.4710397 15.0095534,15.0095534 C13.4710397,16.5480671 11.346,17.5 9,17.5 C6.654,17.5 4.52896028,16.5480671 2.99044661,15.0095534 C1.45193294,13.4710397 0.5,11.346 0.5,9 C0.5,6.654 1.45193294,4.52896028 2.99044661,2.99044661 C4.52896028,1.45193294 6.654,0.5 9,0.5 Z",
    className: "Path",
    stroke: "#1E428A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,13.5 C8.505,13.5 8.1,13.095 8.1,12.6 L8.1,9 C8.1,8.505 8.505,8.1 9,8.1 C9.495,8.1 9.9,8.505 9.9,9 L9.9,12.6 C9.9,13.095 9.495,13.5 9,13.5 Z",
    className: "PathI",
    fill: "#1E428A"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Oval",
    fill: "#1E428A",
    cx: 9,
    cy: 5.4,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.e8f066514222cb4a0e658f25bcf119b2.svg";
export { ForwardRef as ReactComponent };